import React, { useEffect, useState } from 'react';
import { EyeOff, Eye } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/* Compte → confidentialité : apparaître anonyme sur le planning des autres membres. */
export const PortalPrivacyCard = ({ token, playerDisplay = 'names' }) => {
  const [anon, setAnon] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    fetch(`${API_URL}/api/tee-times/portal/settings`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => (r.ok ? r.json() : null)).then(d => d && setAnon(!!d.portal_anonymous)).catch(() => {});
  }, [token]);

  const toggle = async (value) => {
    setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/tee-times/portal/privacy`, { method: 'PATCH', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ portal_anonymous: value }) });
      if (!r.ok) throw new Error('Erreur');
      setAnon(value);
      toast.success(value ? 'Vous apparaissez désormais « Anonyme » sur le planning' : 'Votre nom est de nouveau visible sur le planning');
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <div className="rounded-2xl p-4" style={{ backgroundColor: 'rgba(255,255,255,0.92)', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }} data-testid="portal-privacy-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-start gap-2 min-w-0">
          {anon ? <EyeOff size={16} className="mt-0.5 text-neutral-500 flex-shrink-0" /> : <Eye size={16} className="mt-0.5 text-emerald-600 flex-shrink-0" />}
          <div>
            <p className="text-sm font-semibold text-neutral-800">Apparaître anonyme sur le planning</p>
            <p className="text-[11px] text-neutral-500">
              {playerDisplay === 'none' ? "Le club n'affiche pas les inscrits sur le planning." : playerDisplay === 'index' ? "Le club n'affiche que les index : votre nom n'est jamais visible." : 'Les autres membres verront « Anonyme » à la place de votre nom sur les créneaux.'}
            </p>
          </div>
        </div>
        <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
          <input type="checkbox" className="sr-only peer" checked={anon} disabled={busy} onChange={e => toggle(e.target.checked)} data-testid="portal-anonymous-toggle" />
          <div className="w-10 h-5 bg-neutral-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-emerald-500"></div>
        </label>
      </div>
    </div>
  );
};
